<canvas #barChart></canvas>
